<canvas #barChart></canvas>
